// import { useState, useEffect, useRef } from "react";
// import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
// import { IoMdEye } from "react-icons/io";
// import { MdFilterAlt } from "react-icons/md";
// import { CiSearch } from "react-icons/ci";
// import {
//   getAllChats,
//   createMessage,
//   getMessages,
//   markMessageAsRead,
// } from "../../api/common/chat";
// import { BiSolidBot } from "react-icons/bi";
// import { Link } from "react-router-dom";
// import CustomerSupportIcon from "../../helper/images/customer.png";
// import { useAuth } from "../../context/AuthContext";
// import UserImage from "../../helper/images/customer.png";
// import socket from "../../helper/socket";
// import Chat from "../Chat";
// // import Chat from "../AIChat";
// import SupportChat from "../../Layout/Chat";
// import Queries from "../../Layout/Queries";
// import { useTranslation } from "../../hooks/useTranslation";

// const PopupModal = ({ isOpen, onClose, children }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
//       <div className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[845px] relative sm:shadow-lg">
//         <button
//           onClick={onClose}
//           className="absolute top-[33px] right-[30px] text-[#9E9E9E] hover:text-black"
//         >
//           ✕
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// };

// const PopupModal2 = ({ isOpen, onClose, children }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
//       <div
//         className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[845px] relative sm:shadow-lg
//                            max-h-[90vh] overflow-y-auto"
//       >
//         <button
//           onClick={onClose}
//           className="sticky top-[10px] right-[10px] p-2 float-right text-[#9E9E9E] hover:text-black bg-white"
//         >
//           ✕
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// };

// const CustomerSupport = () => {
//   const { t } = useTranslation();
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [selectedChat, setSelectedChat] = useState(null);
//   const [status, setStatus] = useState("");
//   const [isOpen, setIsOpen] = useState(false);
//   const statuses = [
//     { value: "In Progress", label: t("Support").statuses.inProgress },
//     { value: "Pending", label: t("Support").statuses.pending },
//     { value: "Resolved", label: t("Support").statuses.resolved },
//   ];
//   const [inputMessage, setInputMessage] = useState("");
//   const queryClient = useQueryClient();
//   const { userData } = useAuth();
//   const [isChatPopupOpen, setIsChatPopupOpen] = useState(false);
//   const debouncedMarkAsReadRef = useRef();

//   const { data, isLoading } = useQuery({
//     queryKey: ["allChats"],
//     queryFn: getAllChats,
//   });

//   const { data: messagesData, isLoading: isChatLoading } = useQuery({
//     queryKey: ["all-messages", selectedChat?._id],
//     queryFn: () => getMessages(selectedChat._id),
//     enabled: !!selectedChat?._id,
//   });

//   const chats = data?.data;
//   const messages = messagesData?.data?.messages;

//   const messageMutation = useMutation({
//     mutationFn: createMessage,
//     onSuccess: () => {
//       queryClient.invalidateQueries(["allChats"]);
//       setInputMessage("");
//     },
//   });

//   const messageReadMutation = useMutation({
//     mutationFn: markMessageAsRead,
//     onSuccess: () => {
//       queryClient.invalidateQueries(["allChats"]);
//       setInputMessage("");
//     },
//   });

//   useEffect(() => {
//     if (selectedChat?._id) {
//       socket.emit("joinChat", selectedChat._id);
//       messageReadMutation.mutate(selectedChat?._id);
//     }

//     return () => {
//       if (selectedChat?._id) {
//         socket.emit("leaveRoom", selectedChat._id);
//       }
//     };
//   }, [selectedChat?._id]);

//   useEffect(() => {
//     const handleReceiveMessage = (newMessage) => {
//       queryClient.invalidateQueries(["allChats"]);
//     };
//     socket.on("receiveMessage", handleReceiveMessage);
//     return () => {
//       socket.off("receiveMessage", handleReceiveMessage);
//     };
//   }, []);

//   useEffect(() => {
//     const handleReceiveMessage = (newMessage) => {
//       if (newMessage.chat === selectedChat?._id) {
//         queryClient.invalidateQueries(["all-messages", selectedChat._id]);
//         queryClient.invalidateQueries(["allChats"]);

//         if (debouncedMarkAsReadRef.current) {
//           debouncedMarkAsReadRef.current(selectedChat._id);
//         }
//       }
//     };

//     const handleMessageRead = ({ chatId, userId }) => {
//       if (chatId === selectedChat?._id) {
//         queryClient.setQueryData(["all-messages", chatId], (oldData) => {
//           if (!oldData?.data?.messages) return oldData;

//           const updatedMessages = oldData.data.messages.map((msg) => {
//             if (!msg.readBy?.includes(userId)) {
//               return {
//                 ...msg,
//                 readBy: [...msg.readBy, userId],
//               };
//             }
//             return msg;
//           });

//           return {
//             ...oldData,
//             data: {
//               ...oldData.data,
//               messages: updatedMessages,
//             },
//           };
//         });
//       }
//     };

//     socket.on("receiveMessage", handleReceiveMessage);
//     socket.on("messageRead", handleMessageRead);

//     return () => {
//       socket.off("receiveMessage", handleReceiveMessage);
//       socket.off("messageRead", handleMessageRead);
//     };
//   }, [selectedChat?._id]);

//   const handleView = (chat) => {
//     setSelectedChat(chat);
//     setIsPopupOpen(true);
//   };

//   const totalParticipants = selectedChat?.participants?.length || 1;

//   const debounce = (func, delay) => {
//     let timer;
//     return (...args) => {
//       if (timer) clearTimeout(timer);
//       timer = setTimeout(() => {
//         func(...args);
//       }, delay);
//     };
//   };

//   useEffect(() => {
//     debouncedMarkAsReadRef.current = debounce((chatId) => {
//       messageReadMutation.mutate(chatId);
//     }, 500);

//     return () => {
//       debouncedMarkAsReadRef.current = null;
//     };
//   }, []);

//   return (
//     <div className="container">
//       <div className="w-full py-[50px]">
//         <div className="flex justify-between items-center flex-wrap gap-[20px] ">
//           <h2 className="text-[22px] font-medium">
//             {t("Support").customerSupport}
//           </h2>
//           <div className="relative">
//             <button
//               onClick={() => setIsChatPopupOpen(true)}
//               className="inline-block w-max rounded-[2px] bg-[#FFA808] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] 2xl:px-[18px] p-3 yellow-shadow hover:bg-[#D69723]"
//             >
//               {t("Support").support}
//             </button>
//           </div>
//         </div>

//         <Queries chats={chats} isLoading={isLoading} handleView={handleView} />

//         <PopupModal isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
//           <SupportChat
//             selectedChat={selectedChat}
//             messages={messages}
//             inputMessage={inputMessage}
//             setInputMessage={setInputMessage}
//             messageMutation={messageMutation}
//             userData={userData}
//             totalParticipants={totalParticipants}
//           />
//         </PopupModal>

//         <PopupModal2
//           isOpen={isChatPopupOpen}
//           onClose={() => setIsChatPopupOpen(false)}
//         >
//           <Chat></Chat>
//         </PopupModal2>
//       </div>
//     </div>
//   );
// };

// export default CustomerSupport;
import { useState, useEffect, useRef } from "react";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { IoMdEye } from "react-icons/io";
import { MdFilterAlt } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import {
  getAllChats,
  createMessage,
  getMessages,
  markMessageAsRead,
} from "../../api/common/chat";
import { BiSolidBot } from "react-icons/bi";
import { Link } from "react-router-dom";
import CustomerSupportIcon from "../../helper/images/customer.png";
import { useAuth } from "../../context/AuthContext";
import UserImage from "../../helper/images/customer.png";
import socket from "../../helper/socket";
import Chat from "../Chat";
import SupportChat from "../../Layout/Chat";
import Queries from "../../Layout/Queries";
import { useTranslation } from "../../hooks/useTranslation";

const PopupModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
      <div className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[845px] relative sm:shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-[33px] right-[30px] text-[#9E9E9E] hover:text-black"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const PopupModal2 = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
      <div
        className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[845px] relative sm:shadow-lg max-h-[90vh] overflow-y-auto"
      >
        <button
          onClick={onClose}
          className="sticky top-[10px] right-[10px] p-2 float-right text-[#9E9E9E] hover:text-black bg-white"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const CustomerSupport = () => {
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [status, setStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [inputMessage, setInputMessage] = useState("");
  const queryClient = useQueryClient();
  const { userData } = useAuth();
  const [isChatPopupOpen, setIsChatPopupOpen] = useState(false);
  const debouncedMarkAsReadRef = useRef();

  // ✅ Debounce search input (500ms delay)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  // ✅ Fetch all chats with optional search query
  const { data, isLoading } = useQuery({
    queryKey: ["allChats", debouncedSearch],
    queryFn: () => getAllChats(debouncedSearch),
  });

  const { data: messagesData, isLoading: isChatLoading } = useQuery({
    queryKey: ["all-messages", selectedChat?._id],
    queryFn: () => getMessages(selectedChat._id),
    enabled: !!selectedChat?._id,
  });

  const chats = data?.data;
  const messages = messagesData?.data?.messages;

  const messageMutation = useMutation({
    mutationFn: createMessage,
    onSuccess: () => {
      queryClient.invalidateQueries(["allChats"]);
      setInputMessage("");
    },
  });

  const messageReadMutation = useMutation({
    mutationFn: markMessageAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries(["allChats"]);
      setInputMessage("");
    },
  });

  useEffect(() => {
    if (selectedChat?._id) {
      socket.emit("joinChat", selectedChat._id);
      messageReadMutation.mutate(selectedChat?._id);
    }
    return () => {
      if (selectedChat?._id) {
        socket.emit("leaveRoom", selectedChat._id);
      }
    };
  }, [selectedChat?._id]);

  useEffect(() => {
    const handleReceiveMessage = () => {
      queryClient.invalidateQueries(["allChats"]);
    };
    socket.on("receiveMessage", handleReceiveMessage);
    return () => {
      socket.off("receiveMessage", handleReceiveMessage);
    };
  }, []);

  useEffect(() => {
    const handleReceiveMessage = (newMessage) => {
      if (newMessage.chat === selectedChat?._id) {
        queryClient.invalidateQueries(["all-messages", selectedChat._id]);
        queryClient.invalidateQueries(["allChats"]);

        if (debouncedMarkAsReadRef.current) {
          debouncedMarkAsReadRef.current(selectedChat._id);
        }
      }
    };

    const handleMessageRead = ({ chatId, userId }) => {
      if (chatId === selectedChat?._id) {
        queryClient.setQueryData(["all-messages", chatId], (oldData) => {
          if (!oldData?.data?.messages) return oldData;

          const updatedMessages = oldData.data.messages.map((msg) => {
            if (!msg.readBy?.includes(userId)) {
              return {
                ...msg,
                readBy: [...msg.readBy, userId],
              };
            }
            return msg;
          });

          return {
            ...oldData,
            data: {
              ...oldData.data,
              messages: updatedMessages,
            },
          };
        });
      }
    };

    socket.on("receiveMessage", handleReceiveMessage);
    socket.on("messageRead", handleMessageRead);

    return () => {
      socket.off("receiveMessage", handleReceiveMessage);
      socket.off("messageRead", handleMessageRead);
    };
  }, [selectedChat?._id]);

  const handleView = (chat) => {
    setSelectedChat(chat);
    setIsPopupOpen(true);
  };

  const totalParticipants = selectedChat?.participants?.length || 1;

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  useEffect(() => {
    debouncedMarkAsReadRef.current = debounce((chatId) => {
      messageReadMutation.mutate(chatId);
    }, 500);
    return () => {
      debouncedMarkAsReadRef.current = null;
    };
  }, []);

  return (
    <div className="container">
      <div className="w-full py-[50px]">
        <div className="flex justify-between items-center flex-wrap gap-[20px] ">
          <h2 className="text-[22px] font-medium">
            {t("Support").customerSupport}
          </h2>
          <div className="relative flex items-center gap-3">
            {/* ✅ Search Input */}
            {/* <div className="relative">
              <CiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-lg" />
              <input
                type="text"
                placeholder="Search by Booking / Order / Reservation ID"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-10 pr-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400 w-[280px]"
              />
            </div> */}

            <button
              onClick={() => setIsChatPopupOpen(true)}
              className="inline-block w-max rounded-[2px] bg-[#FFA808] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] 2xl:px-[18px] p-3 yellow-shadow hover:bg-[#D69723]"
            >
              {t("Support").support}
            </button>
          </div>
        </div>

        <Queries chats={chats} isLoading={isLoading} handleView={handleView} search={search} setSearch={setSearch} />

        <PopupModal isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
          <SupportChat
            selectedChat={selectedChat}
            messages={messages}
            inputMessage={inputMessage}
            setInputMessage={setInputMessage}
            messageMutation={messageMutation}
            userData={userData}
            totalParticipants={totalParticipants}
          />
        </PopupModal>

        <PopupModal2
          isOpen={isChatPopupOpen}
          onClose={() => setIsChatPopupOpen(false)}
        >
          <Chat />
        </PopupModal2>
      </div>
    </div>
  );
};

export default CustomerSupport;
